import { Injectable } from "@angular/core";
@Injectable()
export class CollectionsNames {
    public CONFIGURATION = 'configuration';
    public MOBILECONFIGURATION = 'mobileconfiguration';
    public OPERATOR = 'operator';
    public OPERATORANDAPIKEY = 'operatorandapikey';
    public PRINTLIST = 'printlist';
    public CONTACT = 'contact';
    public CUSTOMER = 'customer';
    public DOCUMENTREQUESTTYPE = 'documentRequestType';
    public DOCUMENT = 'document';
    public LIVEDETAILLINES = 'livedetaillines';
    public LIVECONTRACT = 'livecontract';
    public ENGINEER = 'engineer';
    public DEPOT = 'depot';
    public PLANTSTATUSLIST = 'plantstatuslist';
    public JOBSTATUSLIST = 'jobstatuslist';
    public JOBTYPE = 'jobtype';
    public JOBCERTIFICATETEXT = 'jobcertificatetext';
    public QUEUEDDOCUMENTS = 'queueddocuments_using_id';
    public SITE = 'site';
    public EQUIPMENT = 'equipment';
    public EQUIPMENTDISTINCTPDESC = 'equipmentdistinctpdesc';
    public PRODUCTTYPE = 'producttype';
    public SPARESUSEDINWS = 'sparesusedinws';
    public PTSERIAL = 'ptserial';
    public PRICELISTDETAILS = 'pricelistdetails';
    public HACCESS = 'haccess';
    public SACCESS = 'saccess';
    public POLICY = 'policy';
    public PRICELIST = 'pricelist';
    public METERTYPE = 'metertype';
    public HIREDEPT = 'hireDept';
    public HIREDEPTGROUP = 'hireDeptGroup';
    public DEPT = 'dept';
    public DEPTGROUP = 'deptGroup';
    public CUSTOMERLOCATION = 'customerLocation';
    public PROJECT = 'project';
    public SERVICEJOB = 'servicejob';
    public DOCSERVICEJOBTEMP = 'docservicejobtemp';
    public JOBTEMPLATE = 'jobtemplate';
    public MANDATORYMETERS = 'mandatorymeters';
    public TASKS = 'tasks';
    public HRATES = 'hrates';
    public RETURN = 'return';
    public CASHACCOUNTS = 'cashaccounts';
    public PAYMENTMETHODS = 'paymentmethods';
    public SYSTEMCONFIGURATION = 'systemconfiguration';
    public ERRORLOG = 'errorlog';
    public ACTION = 'action';
    public QUEUEDACTION = 'queuedaction';
    public ACTIONTYPE = 'actiontype';
    public ACTIONPRIORITY = 'actionpriority';
    public SCREENPREFERENCES = 'screenpreferences';
    public STOCKCOUNTS = 'stockcounts';
    public PRODUCTBARCODESTOCKTAKE = 'productbarcodestocktake';
    public SCANNEDBARCODES = 'scannedbarcodes';
    public BINLOCATIONS = 'binlocations';
    public DEFAULTBUNDLEITEMS = 'defaultbundleitems';

    collectionNamesEnum = {
        CONFIGURATION: 'configuration',
        MOBILECONFIGURATION: 'mobileconfiguration',
        OPERATOR: 'operator',
        OPERATORANDAPIKEY: 'operatorandapikey',
        PRINTLIST: 'printlist',
        CONTACT: 'contact',
        CUSTOMER: 'customer',
        DOCUMENTREQUESTTYPE: 'documentRequestType',
        DOCUMENT: 'document',
        LIVEDETAILLINES: 'livedetaillines',
        LIVECONTRACT: 'livecontract',
        ENGINEER: 'engineer',
        DEPOT: 'depot',
        PLANTSTATUSLIST: 'plantstatuslist',
        JOBSTATUSLIST: 'jobstatuslist',
        JOBTYPE: 'jobtype',
        JOBCERTIFICATETEXT: 'jobcertificatetext',
        QUEUEDDOCUMENTS: 'queueddocuments_using_id',
        SITE: 'site',
        EQUIPMENT: 'equipment',
        EQUIPMENTDISTINCTPDESC: 'equipmentdistinctpdesc',
        PRODUCTTYPE: 'producttype',
        SPARESUSEDINWS: 'sparesusedinws',
        PTSERIAL: 'ptserial',
        PRICELISTDETAILS: 'pricelistdetails',
        HACCESS: 'haccess',
        SACCESS: 'saccess',
        POLICY: 'policy',
        PRICELIST: 'pricelist',
        METERTYPE: 'metertype',
        HIREDEPT: 'hireDept',
        HIREDEPTGROUP: 'hireDeptGroup',
        DEPT: 'dept',
        DEPTGROUP: 'deptGroup',
        CUSTOMERLOCATION: 'customerLocation',
        PROJECT: 'project',
        SERVICEJOB: 'servicejob',
        DOCSERVICEJOBTEMP: 'docservicejobtemp',
        JOBTEMPLATE: 'jobtemplate',
        MANDATORYMETERS: 'mandatorymeters',
        TASKS: 'tasks',
        HRATES: 'hrates',
        RETURN: 'return',
        CASHACCOUNTS: 'cashaccounts',
        PAYMENTMETHODS: 'paymentmethods',
        SYSTEMCONFIGURATION: 'systemconfiguration',
        ERRORLOG: 'errorlog',
        ACTION: 'action',
        QUEUEDACTION: 'queuedaction',
        ACTIONTYPE: 'actiontype',
        ACTIONPRIORITY: 'actionpriority',
        SCREENPREFERENCES: 'screenpreferences',
        STOCKCOUNTS: 'stockcounts',
        PRODUCTBARCODESTOCKTAKE: 'productbarcodestocktake',
        SCANNEDBARCODES: 'scannedbarcodes',
        BINLOCATIONS: 'binlocations',
        DEFAULTBUNDLEITEMS: 'defaultbundleitems'

    };
}
